import React from "react";

const AdminLoginPage = () => {
  return <div>AdminLoginPage</div>;
};

export default AdminLoginPage;
